"use strict";

let config = {
  env: "QA",
  alkmapsUrl: "//maps-aws-qa.alk.com/api/1.2/ALKMaps.js",
  alkmapsApiKey: "48667533B12E8942B038B8533A35F4A5",
  reportApiKey: {
    "NA" : "7BD8599CEA4B8A46AC336735444E486C",
    "EU" : "48667533B12E8942B038B8533A35F4A5",
    "OC" : "48667533B12E8942B038B8533A35F4A5"
  },
  braze: {
    apiKey: "01e442af-cfcb-43ba-b63f-dbef1f587dac",
    // make this value smaller before demoing
    minimumIntervalBetweenTriggerActionsInSeconds: 30,
    enableLogging: true
  },
  chat: {
    enabled: true,
    regionWhitelist: [
      "NA"
    ],
    scriptUrl: "https://wchat.freshchat.com/js/widget.js",
    // shared token for all environments
    fcToken: "797ed190-4ef3-4faa-81f8-367d7ba5e6dc",
  },
  pcmwsUrl: "https://pcmiler-aws-qa.alk.com/APIs/REST/v1.0/service.svc/",
  urlWeatherRadar: "https://aws.contentsvc.qa.alk.com/ContentService.svc/xml/WeatherImageTile?x=${x}&y=${y}&z=${z}&weatherDisplay=0&authtoken=",
  urlWeatherSatellite: "https://aws.contentsvc.qa.alk.com/ContentService.svc/xml/WeatherImageTile?x=${x}&y=${y}&z=${z}&weatherDisplay=1&authtoken=",
  daUrl: "https://dataanywhere-qa.alk.com/api/",
  ssoUrl: "https://authws-qa.alk.com/api/",
  fleetLinkUrl: "https://api-copilotfleetportal-qa.alk.com/",
  singleSearchUrl: "https://singlesearch-aws-qa.alk.com/ww/api/search/",
  singleSearchAuthToken: "A7FEE5D40BDF4A4A97D623094A657AFB",
  alkiconsUrl: "https://maps.trimble.com/fonts/alk-icons.min.css",
  linkMappingUrl: "https://linkmapping-qa.alk.com/api",
  creditExpireWarningDays: 14,
  trackJsEnvironment: "pcmwebui-qa",
  applicationName: "PCMilerWebsite",
  tidApplicationName:"PC_Miler_Web--dev-qa",
  clientId :"4340ee42-2cd9-4fc6-9c3e-2721ae85e384",
  trimbleCloudUrl:"https://stage.id.trimblecloud.com/",
  alkCloudApplicationName: "PC*Miler Interactive",
  promo: {
    userId: 11553434,
    accountId: 127896
  },
  pcmModernSite: "https://qa.pcmilerweb.com/",
  sumoUrl:"https://collectors.us2.sumologic.com/receiver/v1/http/ZaVnC4dhaV3NqK1vVtGOb0Fly8fu4vYhxD_B70jkxrlh33lFU53ial6DElnwM9kHMctfNvhXGVcis-2-dxiDOmDQ3w-S3fo7i2R0Up-n6sX1lQRT67QAOg=="
};

module.exports = config;


// WEBPACK FOOTER //
// ./js/config/alkqaaws.js